import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const reducer = createSlice({
  name: 'permissions.reducer',
  initialState: {
    mic: {
      granted: false,
      canAskAgain: false,
    },
    camera: {
      granted: false,
      canAskAgain: false,
    },
  },
  reducers: {
    actionSetMicPermission(state, action: PayloadAction<{ granted: boolean; canAskAgain: boolean }>) {
      state.mic = {
        granted: action.payload.granted,
        canAskAgain: action.payload.canAskAgain,
      };
    },
    actionSetCameraPermission(state, action: PayloadAction<{ granted: boolean; canAskAgain: boolean }>) {
      state.camera = {
        granted: action.payload.granted,
        canAskAgain: action.payload.canAskAgain,
      };
    },
  },
});

export const { actionSetMicPermission, actionSetCameraPermission } = reducer.actions;
export default reducer.reducer;
